import React from "react";
import Box from "@mui/material/Box";
import { COLORS } from "../theme/tokens";

export default function VariantOneLegacyPageFrame({ children }) {
  return (
    <Box
      component="main"
      sx={{
        backgroundColor: COLORS.paper,
        color: COLORS.ink,
        px: "clamp(20px, 5vw, 72px)",
        py: "clamp(42px, 6vw, 84px)",
        minHeight: "58vh",
      }}
    >
      <Box
        sx={{
          maxWidth: 1160,
          mx: "auto",
          backgroundColor: "#fff",
          border: `1px solid ${COLORS.line}`,
          borderRadius: 1,
          boxShadow: "0 16px 36px rgba(32, 48, 51, 0.08)",
          p: "clamp(24px, 4vw, 48px)",
          overflow: "hidden",
          "& > div, & > section, & > article, & > .MuiContainer-root": {
            maxWidth: "none !important",
            marginLeft: "0 !important",
            marginRight: "0 !important",
            marginTop: "0 !important",
            width: "100% !important",
          },
          "& .MuiContainer-root": {
            paddingLeft: "0 !important",
            paddingRight: "0 !important",
          },
          "& h1, & .MuiTypography-h1, & .MuiTypography-h2, & .MuiTypography-h3, & .MuiTypography-h4, & .MuiTypography-h5":
            {
              fontFamily: "windroos, Georgia, serif",
              color: `${COLORS.blue} !important`,
              lineHeight: 1.08,
              marginTop: "0 !important",
            },
          "& .MuiTypography-body1, & .MuiTypography-body2, & p, & li": {
            color: `${COLORS.ink} !important`,
            lineHeight: 1.65,
          },
          "& a": {
            color: COLORS.red,
            fontWeight: 700,
          },
          "& img": {
            maxWidth: "100%",
            height: "auto",
            borderRadius: "8px !important",
          },
          "& table": {
            minWidth: "0 !important",
          },
          "& .MuiTableContainer-root": {
            borderRadius: 1,
            border: `1px solid ${COLORS.line}`,
            boxShadow: "none",
          },
          "& .MuiTabs-root": {
            borderBottom: `1px solid ${COLORS.line}`,
          },
          "& .MuiTab-root": {
            color: COLORS.muted,
            fontWeight: 700,
            textTransform: "none",
          },
          "& .Mui-selected": {
            color: `${COLORS.red} !important`,
          },
          "& .MuiAccordion-root, & .MuiCard-root, & .MuiPaper-root": {
            borderRadius: "8px !important",
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
